// This file is auto-generated. Do not edit manually.
    import { RentLocationInfo } from "@/lib/types/listing";
  export const rentLocations: Record<string, RentLocationInfo> = {
  "alkmaar": {
    "count": 25,
    "countAllTime": 1071,
    "localizedNames": {
      "de": "Alkmaar",
      "en": "Alkmaar",
      "es": "Alkmaar",
      "fr": "Alkmaar",
      "nl": "Alkmaar"
    },
    "names": [
      "Alkmaar"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "almelo": {
    "count": 15,
    "countAllTime": 271,
    "localizedNames": {
      "de": "Almelo",
      "en": "Almelo",
      "es": "Almelo",
      "fr": "Almelo",
      "nl": "Almelo"
    },
    "names": [
      "Almelo"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "almere": {
    "count": 60,
    "countAllTime": 1912,
    "localizedNames": {
      "de": "Almere",
      "en": "Almere",
      "es": "Almere",
      "fr": "Almere",
      "nl": "Almere"
    },
    "names": [
      "Almere"
    ],
    "platformsCount": 3,
    "type": "CITY"
  },
  "alphen-aan-den-rijn": {
    "count": 12,
    "countAllTime": 427,
    "localizedNames": {
      "de": "Alphen aan den Rijn",
      "en": "Alphen aan den Rijn",
      "es": "Alphen aan den Rijn",
      "fr": "Alphen-sur-le-Rhin",
      "nl": "Alphen aan den Rijn"
    },
    "names": [
      "Alphen aan den Rijn",
      "Alphen-sur-le-Rhin"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "amersfoort": {
    "count": 26,
    "countAllTime": 944,
    "localizedNames": {
      "de": "Amersfoort",
      "en": "Amersfoort",
      "es": "Amersfoort",
      "fr": "Amersfoort",
      "nl": "Amersfoort"
    },
    "names": [
      "Amersfoort"
    ],
    "platformsCount": 4,
    "type": "CITY"
  },
  "amstelveen": {
    "count": 46,
    "countAllTime": 1922,
    "localizedNames": {
      "de": "Amstelveen",
      "en": "Amstelveen",
      "es": "Amstelveen",
      "fr": "Amstelveen",
      "nl": "Amstelveen"
    },
    "names": [
      "Amstelveen"
    ],
    "platformsCount": 3,
    "type": "CITY"
  },
  "amsterdam": {
    "count": 741,
    "countAllTime": 26361,
    "localizedNames": {
      "de": "Amsterdam",
      "en": "Amsterdam",
      "es": "Amsterdam",
      "fr": "Amsterdam",
      "nl": "Amsterdam"
    },
    "names": [
      "Amsterdam"
    ],
    "platformsCount": 56,
    "type": "CITY"
  },
  "apeld-centrum": {
    "count": 18,
    "countAllTime": 87,
    "localizedNames": {
      "de": "Centrum",
      "en": "Centrum",
      "es": "Centrum",
      "fr": "Centrum",
      "nl": "Centrum"
    },
    "names": [
      "Centrum"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "apeld-zuidoost": {
    "count": 11,
    "countAllTime": 43,
    "localizedNames": {
      "de": "Zuidoost",
      "en": "Zuidoost",
      "es": "Zuidoost",
      "fr": "Zuidoost",
      "nl": "Zuidoost"
    },
    "names": [
      "Zuidoost"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "apeldoorn": {
    "count": 56,
    "countAllTime": 1119,
    "localizedNames": {
      "de": "Apeldoorn",
      "en": "Apeldoorn",
      "es": "Apeldoorn",
      "fr": "Apeldoorn",
      "nl": "Apeldoorn"
    },
    "names": [
      "Apeldoorn"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "arnhe-centrum": {
    "count": 12,
    "countAllTime": 197,
    "localizedNames": {
      "de": "Centrum",
      "en": "Centrum",
      "es": "Centrum",
      "fr": "Centrum",
      "nl": "Centrum"
    },
    "names": [
      "Centrum"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "arnhem": {
    "count": 76,
    "countAllTime": 2316,
    "localizedNames": {
      "de": "Arnhem",
      "en": "Arnhem",
      "es": "Arnhem",
      "fr": "Arnhem",
      "nl": "Arnhem"
    },
    "names": [
      "Arnhem"
    ],
    "platformsCount": 4,
    "type": "CITY"
  },
  "assen": {
    "count": 23,
    "countAllTime": 819,
    "localizedNames": {
      "de": "Assen",
      "en": "Assen",
      "es": "Assen",
      "fr": "Assen",
      "nl": "Assen"
    },
    "names": [
      "Assen"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "bergen-op-zoom": {
    "count": 17,
    "countAllTime": 426,
    "localizedNames": {
      "de": "Bergen op Zoom",
      "en": "Bergen op Zoom",
      "es": "Bergen op Zoom",
      "fr": "Bergen op Zoom",
      "nl": "Bergen op Zoom"
    },
    "names": [
      "Bergen op Zoom"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "bergpolder": {
    "count": 17,
    "countAllTime": 17,
    "localizedNames": {
      "de": "Bergpolder",
      "en": "Bergpolder",
      "es": "Bergpolder",
      "fr": "Bergpolder",
      "nl": "Bergpolder"
    },
    "names": [
      "Bergpolder"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "blijdorp": {
    "count": 15,
    "countAllTime": 15,
    "localizedNames": {
      "de": "Blijdorp",
      "en": "Blijdorp",
      "es": "Blijdorp",
      "fr": "Blijdorp",
      "nl": "Blijdorp"
    },
    "names": [
      "Blijdorp"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "bloemhof": {
    "count": 16,
    "countAllTime": 16,
    "localizedNames": {
      "de": "Bloemhof",
      "en": "Bloemhof",
      "es": "Bloemhof",
      "fr": "Bloemhof",
      "nl": "Bloemhof"
    },
    "names": [
      "Bloemhof"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "bospolder": {
    "count": 11,
    "countAllTime": 11,
    "localizedNames": {
      "de": "Bospolder",
      "en": "Bospolder",
      "es": "Bospolder",
      "fr": "Bospolder",
      "nl": "Bospolder"
    },
    "names": [
      "Bospolder"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "breda": {
    "count": 126,
    "countAllTime": 3063,
    "localizedNames": {
      "de": "Breda",
      "en": "Breda",
      "es": "Breda",
      "fr": "Bréda",
      "nl": "Breda"
    },
    "names": [
      "Breda",
      "Bréda"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "brunssum": {
    "count": 18,
    "countAllTime": 227,
    "localizedNames": {
      "de": "Brunssum",
      "en": "Brunssum",
      "es": "Brunssum",
      "fr": "Brunssum",
      "nl": "Brunssum"
    },
    "names": [
      "Brunssum"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "capelle-aan-den-ijssel": {
    "count": 26,
    "countAllTime": 405,
    "localizedNames": {
      "de": "Capelle aan den IJssel",
      "en": "Capelle aan den IJssel",
      "es": "Capelle aan den IJssel",
      "fr": "Capelle aan den IJssel",
      "nl": "Capelle aan den IJssel"
    },
    "names": [
      "Capelle aan den IJssel"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "carnisse": {
    "count": 14,
    "countAllTime": 14,
    "localizedNames": {
      "de": "Carnisse",
      "en": "Carnisse",
      "es": "Carnisse",
      "fr": "Carnisse",
      "nl": "Carnisse"
    },
    "names": [
      "Carnisse"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "centr-bergen": {
    "count": 27,
    "countAllTime": 27,
    "localizedNames": {
      "de": "Bergen",
      "en": "Bergen",
      "es": "Bergen",
      "fr": "Bergen",
      "nl": "Bergen"
    },
    "names": [
      "Bergen"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "centr-binnenstad-noord": {
    "count": 14,
    "countAllTime": 14,
    "localizedNames": {
      "de": "Binnenstad-Noord",
      "en": "Binnenstad-Noord",
      "es": "Binnenstad-Noord",
      "fr": "Binnenstad-Noord",
      "nl": "Binnenstad-Noord"
    },
    "names": [
      "Binnenstad-Noord"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "centr-binnenstad-zuid": {
    "count": 25,
    "countAllTime": 25,
    "localizedNames": {
      "de": "Binnenstad-Zuid",
      "en": "Binnenstad-Zuid",
      "es": "Binnenstad-Zuid",
      "fr": "Binnenstad-Zuid",
      "nl": "Binnenstad-Zuid"
    },
    "names": [
      "Binnenstad-Zuid"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "centr-fellenoord": {
    "count": 12,
    "countAllTime": 12,
    "localizedNames": {
      "de": "Fellenoord",
      "en": "Fellenoord",
      "es": "Fellenoord",
      "fr": "Fellenoord",
      "nl": "Fellenoord"
    },
    "names": [
      "Fellenoord"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "centrum-rcigi": {
    "count": 11,
    "countAllTime": 272,
    "localizedNames": {
      "de": "Centrum",
      "en": "Centrum",
      "es": "Centrum",
      "fr": "Centrum",
      "nl": "Centrum"
    },
    "names": [
      "Centrum"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "charlois": {
    "count": 48,
    "countAllTime": 972,
    "localizedNames": {
      "de": "Charlois",
      "en": "Charlois",
      "es": "Charlois",
      "fr": "Charlois",
      "nl": "Charlois"
    },
    "names": [
      "Charlois"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "delfs-middelland": {
    "count": 13,
    "countAllTime": 13,
    "localizedNames": {
      "de": "Middelland",
      "en": "Middelland",
      "es": "Middelland",
      "fr": "Middelland",
      "nl": "Middelland"
    },
    "names": [
      "Middelland"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "delft": {
    "count": 125,
    "countAllTime": 3188,
    "localizedNames": {
      "de": "Delft",
      "en": "Delft",
      "es": "Delft",
      "fr": "Delft",
      "nl": "Delft"
    },
    "names": [
      "Delft"
    ],
    "platformsCount": 6,
    "type": "CITY"
  },
  "den-haag": {
    "count": 424,
    "countAllTime": 10694,
    "localizedNames": {
      "de": "Den Haag",
      "en": "The Hague",
      "es": "La Haya",
      "fr": "La Haye",
      "nl": "Den Haag"
    },
    "names": [
      "Den Haag",
      "The Hague",
      "s-Gravenhage",
      "'s-Gravenhage",
      "Gravenhage",
      "La Haya",
      "Haag",
      "La Haye",
      "L-Aja",
      "Haga"
    ],
    "platformsCount": 48,
    "type": "CITY"
  },
  "den-helder": {
    "count": 18,
    "countAllTime": 431,
    "localizedNames": {
      "de": "Den Helder",
      "en": "Den Helder",
      "es": "Den Helder",
      "fr": "Le Helder",
      "nl": "Den Helder"
    },
    "names": [
      "Den Helder",
      "Le Helder"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "deven-binnenstad": {
    "count": 14,
    "countAllTime": 302,
    "localizedNames": {
      "de": "Binnenstad",
      "en": "Binnenstad",
      "es": "Binnenstad",
      "fr": "Binnenstad",
      "nl": "Binnenstad"
    },
    "names": [
      "Binnenstad"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "deventer": {
    "count": 36,
    "countAllTime": 1014,
    "localizedNames": {
      "de": "Deventer",
      "en": "Deventer",
      "es": "Deventer",
      "fr": "Deventer",
      "nl": "Deventer"
    },
    "names": [
      "Deventer"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "diemen": {
    "count": 31,
    "countAllTime": 766,
    "localizedNames": {
      "de": "Diemen",
      "en": "Diemen",
      "es": "Diemen",
      "fr": "Diemen",
      "nl": "Diemen"
    },
    "names": [
      "Diemen"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "doetinchem": {
    "count": 15,
    "countAllTime": 305,
    "localizedNames": {
      "de": "Doetinchem",
      "en": "Doetinchem",
      "es": "Doetinchem",
      "fr": "Doetinchem",
      "nl": "Doetinchem"
    },
    "names": [
      "Doetinchem"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "dordrecht": {
    "count": 20,
    "countAllTime": 428,
    "localizedNames": {
      "de": "Dordrecht",
      "en": "Dordrecht",
      "es": "Dordrecht",
      "fr": "Dordrecht",
      "nl": "Dordrecht"
    },
    "names": [
      "Dordrecht"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "drechterland": {
    "count": 9,
    "countAllTime": 25,
    "localizedNames": {
      "de": "Drechterland",
      "en": "Drechterland",
      "es": "Drechterland",
      "fr": "Drechterland",
      "nl": "Drechterland"
    },
    "names": [
      "Drechterland",
      "Hoogkarspel",
      "Venhuizen"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "drenthe": {
    "count": 122,
    "countAllTime": 3158,
    "localizedNames": {
      "de": "Drenthe",
      "en": "Drenthe",
      "es": "Drente",
      "fr": "Drenthe",
      "nl": "Drenthe"
    },
    "names": [
      "Drenthe",
      "Drente"
    ],
    "platformsCount": 5,
    "type": "PROVINCE"
  },
  "edam-volendam": {
    "count": 12,
    "countAllTime": 50,
    "localizedNames": {
      "de": "Edam-Volendam",
      "en": "Edam-Volendam",
      "es": "Edam-Volendam",
      "fr": "Edam-Volendam",
      "nl": "Edam-Volendam"
    },
    "names": [
      "Edam-Volendam",
      "Edam",
      "Oosthuizen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "ede": {
    "count": 18,
    "countAllTime": 453,
    "localizedNames": {
      "de": "Ede",
      "en": "Ede",
      "es": "Ede",
      "fr": "Ede",
      "nl": "Ede"
    },
    "names": [
      "Ede"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "eindh-centrum": {
    "count": 134,
    "countAllTime": 920,
    "localizedNames": {
      "de": "Centrum",
      "en": "Centrum",
      "es": "Centrum",
      "fr": "Centrum",
      "nl": "Centrum"
    },
    "names": [
      "Centrum"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "eindhoven": {
    "count": 646,
    "countAllTime": 5968,
    "localizedNames": {
      "de": "Eindhoven",
      "en": "Eindhoven",
      "es": "Eindhoven",
      "fr": "Eindhoven",
      "nl": "Eindhoven"
    },
    "names": [
      "Eindhoven"
    ],
    "platformsCount": 44,
    "type": "CITY"
  },
  "emmen": {
    "count": 28,
    "countAllTime": 533,
    "localizedNames": {
      "de": "Emmen",
      "en": "Emmen",
      "es": "Emmen",
      "fr": "Emmen",
      "nl": "Emmen"
    },
    "names": [
      "Emmen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "enkhuizen": {
    "count": 48,
    "countAllTime": 96,
    "localizedNames": {
      "de": "Enkhuizen",
      "en": "Enkhuizen",
      "es": "Encusa",
      "fr": "Enkhuizen",
      "nl": "Enkhuizen"
    },
    "names": [
      "Enkhuizen",
      "Encusa"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "enschede": {
    "count": 155,
    "countAllTime": 4944,
    "localizedNames": {
      "de": "Enschede",
      "en": "Enschede",
      "es": "Enschede",
      "fr": "Enschede",
      "nl": "Enschede"
    },
    "names": [
      "Enschede",
      "Eanske"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "etten-leur": {
    "count": 8,
    "countAllTime": 250,
    "localizedNames": {
      "de": "Etten-Leur",
      "en": "Etten-Leur",
      "es": "Etten-Leur",
      "fr": "Etten-Leur",
      "nl": "Etten-Leur"
    },
    "names": [
      "Etten-Leur"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "flevoland": {
    "count": 132,
    "countAllTime": 3022,
    "localizedNames": {
      "de": "Flevoland",
      "en": "Flevoland",
      "es": "Flevolanda",
      "fr": "Flevoland",
      "nl": "Flevoland"
    },
    "names": [
      "Flevoland",
      "Flevolanda"
    ],
    "platformsCount": 11,
    "type": "PROVINCE"
  },
  "frysln": {
    "count": 164,
    "countAllTime": 5633,
    "localizedNames": {
      "de": "Friesland",
      "en": "Friesland",
      "es": "Frisia",
      "fr": "Frise",
      "nl": "Fryslân"
    },
    "names": [
      "Fryslân",
      "Friesland",
      "Frisia",
      "Friisimaa",
      "Friisinmaa",
      "Frise",
      "Frísland",
      "Fryzja"
    ],
    "platformsCount": 10,
    "type": "PROVINCE"
  },
  "gelderland": {
    "count": 399,
    "countAllTime": 11185,
    "localizedNames": {
      "de": "Gelderland",
      "en": "Gelderland",
      "es": "Güeldres",
      "fr": "Gueldre",
      "nl": "Gelderland"
    },
    "names": [
      "Gelderland",
      "Guelders",
      "Güeldres",
      "Gueldre",
      "Geldria"
    ],
    "platformsCount": 40,
    "type": "PROVINCE"
  },
  "geldrop-mierlo": {
    "count": 12,
    "countAllTime": 187,
    "localizedNames": {
      "de": "Geldrop-Mierlo",
      "en": "Geldrop-Mierlo",
      "es": "Geldrop-Mierlo",
      "fr": "Geldrop-Mierlo",
      "nl": "Geldrop-Mierlo"
    },
    "names": [
      "Geldrop-Mierlo",
      "Geldrop"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "goes": {
    "count": 12,
    "countAllTime": 341,
    "localizedNames": {
      "de": "Goes",
      "en": "Goes",
      "es": "Goes",
      "fr": "Goes",
      "nl": "Goes"
    },
    "names": [
      "Goes"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "groni-centrum": {
    "count": 75,
    "countAllTime": 2016,
    "localizedNames": {
      "de": "Centrum",
      "en": "Centrum",
      "es": "Centrum",
      "fr": "Centrum",
      "nl": "Centrum"
    },
    "names": [
      "Centrum"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "groningen": {
    "count": 261,
    "countAllTime": 8068,
    "localizedNames": {
      "de": "Groningen",
      "en": "Groningen",
      "es": "Groninga",
      "fr": "Groningue",
      "nl": "Groningen"
    },
    "names": [
      "Groningen",
      "Groninga",
      "Groningue"
    ],
    "platformsCount": 17,
    "type": "CITY"
  },
  "groningen-province": {
    "count": 325,
    "countAllTime": 9119,
    "localizedNames": {
      "de": "Groningen",
      "en": "Groningen",
      "es": "Groninga",
      "fr": "Groningue",
      "nl": "Groningen"
    },
    "names": [
      "Groningen",
      "Grunnen",
      "Groninga",
      "Groningue"
    ],
    "platformsCount": 17,
    "type": "PROVINCE"
  },
  "haarlem": {
    "count": 103,
    "countAllTime": 2374,
    "localizedNames": {
      "de": "Haarlem",
      "en": "Haarlem",
      "es": "Haarlem",
      "fr": "Haarlem",
      "nl": "Haarlem"
    },
    "names": [
      "Haarlem"
    ],
    "platformsCount": 5,
    "type": "CITY"
  },
  "haarlemmermeer": {
    "count": 39,
    "countAllTime": 1145,
    "localizedNames": {
      "de": "Haarlemmermeer",
      "en": "Haarlemmermeer",
      "es": "Haarlemmermeer",
      "fr": "Haarlemmermeer",
      "nl": "Haarlemmermeer"
    },
    "names": [
      "Haarlemmermeer",
      "Hoofddorp",
      "Nieuw-Vennep"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "heerenveen": {
    "count": 10,
    "countAllTime": 387,
    "localizedNames": {
      "de": "Heerenveen",
      "en": "Heerenveen",
      "es": "Heerenveen",
      "fr": "Heerenveen",
      "nl": "Heerenveen"
    },
    "names": [
      "Heerenveen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "heerhugowaard": {
    "count": 9,
    "countAllTime": 336,
    "localizedNames": {
      "de": "Heerhugowaard",
      "en": "Heerhugowaard",
      "es": "Heerhugowaard",
      "fr": "Heerhugowaard",
      "nl": "Heerhugowaard"
    },
    "names": [
      "Heerhugowaard"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "heerlen": {
    "count": 58,
    "countAllTime": 1503,
    "localizedNames": {
      "de": "Heerlen",
      "en": "Heerlen",
      "es": "Heerlen",
      "fr": "Heerlen",
      "nl": "Heerlen"
    },
    "names": [
      "Heerlen",
      "Hoensbroek"
    ],
    "platformsCount": 3,
    "type": "CITY"
  },
  "helmond": {
    "count": 11,
    "countAllTime": 538,
    "localizedNames": {
      "de": "Helmond",
      "en": "Helmond",
      "es": "Helmond",
      "fr": "Helmond",
      "nl": "Helmond"
    },
    "names": [
      "Helmond"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "hengelo-o": {
    "count": 19,
    "countAllTime": 572,
    "localizedNames": {
      "de": "Hengelo",
      "en": "Hengelo",
      "es": "Hengelo",
      "fr": "Hengelo",
      "nl": "Hengelo"
    },
    "names": [
      "Hengelo (O)",
      "Hengelo",
      "Hengelo (OV)"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "hillegersberg-schiebroek": {
    "count": 12,
    "countAllTime": 349,
    "localizedNames": {
      "de": "Hillegersberg-Schiebroek",
      "en": "Hillegersberg-Schiebroek",
      "es": "Hillegersberg-Schiebroek",
      "fr": "Hillegersberg-Schiebroek",
      "nl": "Hillegersberg-Schiebroek"
    },
    "names": [
      "Hillegersberg-Schiebroek"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "hilversum": {
    "count": 37,
    "countAllTime": 1018,
    "localizedNames": {
      "de": "Hilversum",
      "en": "Hilversum",
      "es": "Hilversum",
      "fr": "Hilversum",
      "nl": "Hilversum"
    },
    "names": [
      "Hilversum"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "hoogeveen": {
    "count": 13,
    "countAllTime": 231,
    "localizedNames": {
      "de": "Hoogeveen",
      "en": "Hoogeveen",
      "es": "Hoogeveen",
      "fr": "Hoogeveen",
      "nl": "Hoogeveen"
    },
    "names": [
      "Hoogeveen"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "huizen": {
    "count": 9,
    "countAllTime": 177,
    "localizedNames": {
      "de": "Huizen",
      "en": "Huizen",
      "es": "Huizen",
      "fr": "Huizen",
      "nl": "Huizen"
    },
    "names": [
      "Huizen"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "ijsselmonde": {
    "count": 18,
    "countAllTime": 416,
    "localizedNames": {
      "de": "IJsselmonde",
      "en": "IJsselmonde",
      "es": "IJsselmonde",
      "fr": "IJsselmonde",
      "nl": "IJsselmonde"
    },
    "names": [
      "IJsselmonde"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "katendrecht": {
    "count": 19,
    "countAllTime": 19,
    "localizedNames": {
      "de": "Katendrecht",
      "en": "Katendrecht",
      "es": "Katendrecht",
      "fr": "Katendrecht",
      "nl": "Katendrecht"
    },
    "names": [
      "Katendrecht"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "kerkrade": {
    "count": 24,
    "countAllTime": 459,
    "localizedNames": {
      "de": "Kerkrade",
      "en": "Kerkrade",
      "es": "Kerkrade",
      "fr": "Kerkrade",
      "nl": "Kerkrade"
    },
    "names": [
      "Kerkrade"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "leeuwarden": {
    "count": 67,
    "countAllTime": 2485,
    "localizedNames": {
      "de": "Leeuwarden",
      "en": "Leeuwarden",
      "es": "Leeuwarden",
      "fr": "Leeuwarden",
      "nl": "Leeuwarden"
    },
    "names": [
      "Leeuwarden"
    ],
    "platformsCount": 4,
    "type": "CITY"
  },
  "leiden": {
    "count": 85,
    "countAllTime": 2827,
    "localizedNames": {
      "de": "Leiden",
      "en": "Leiden",
      "es": "Leiden",
      "fr": "Leyde",
      "nl": "Leiden"
    },
    "names": [
      "Leiden",
      "Leyde",
      "Lejda"
    ],
    "platformsCount": 7,
    "type": "CITY"
  },
  "leidschendam-voorburg": {
    "count": 32,
    "countAllTime": 738,
    "localizedNames": {
      "de": "Leidschendam-Voorburg",
      "en": "Leidschendam-Voorburg",
      "es": "Leidschendam-Voorburg",
      "fr": "Leidschendam-Voorburg",
      "nl": "Leidschendam-Voorburg"
    },
    "names": [
      "Leidschendam-Voorburg",
      "Leidschendam",
      "Voorburg"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "lelys-stadshart": {
    "count": 11,
    "countAllTime": 70,
    "localizedNames": {
      "de": "Stadshart",
      "en": "Stadshart",
      "es": "Stadshart",
      "fr": "Stadshart",
      "nl": "Stadshart"
    },
    "names": [
      "Stadshart"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "lelystad": {
    "count": 62,
    "countAllTime": 685,
    "localizedNames": {
      "de": "Lelystad",
      "en": "Lelystad",
      "es": "Lelystad",
      "fr": "Lelystad",
      "nl": "Lelystad"
    },
    "names": [
      "Lelystad"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "limbu-weert": {
    "count": 16,
    "countAllTime": 362,
    "localizedNames": {
      "de": "Weert",
      "en": "Weert",
      "es": "Weert",
      "fr": "Weert",
      "nl": "Weert"
    },
    "names": [
      "Weert"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "limburg": {
    "count": 468,
    "countAllTime": 13316,
    "localizedNames": {
      "de": "Limburg",
      "en": "Limburg",
      "es": "Limburgo",
      "fr": "Limbourg",
      "nl": "Limburg"
    },
    "names": [
      "Limburg",
      "Limburgo",
      "Limbourg",
      "Limburgia"
    ],
    "platformsCount": 15,
    "type": "PROVINCE"
  },
  "lisse": {
    "count": 12,
    "countAllTime": 212,
    "localizedNames": {
      "de": "Lisse",
      "en": "Lisse",
      "es": "Lisse",
      "fr": "Lisse",
      "nl": "Lisse"
    },
    "names": [
      "Lisse"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "maastricht": {
    "count": 142,
    "countAllTime": 5167,
    "localizedNames": {
      "de": "Maastricht",
      "en": "Maastricht",
      "es": "Maastricht",
      "fr": "Maastricht",
      "nl": "Maastricht"
    },
    "names": [
      "Maastricht"
    ],
    "platformsCount": 8,
    "type": "CITY"
  },
  "meerzicht": {
    "count": 11,
    "countAllTime": 78,
    "localizedNames": {
      "de": "Meerzicht",
      "en": "Meerzicht",
      "es": "Meerzicht",
      "fr": "Meerzicht",
      "nl": "Meerzicht"
    },
    "names": [
      "Meerzicht"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "meppel": {
    "count": 11,
    "countAllTime": 248,
    "localizedNames": {
      "de": "Meppel",
      "en": "Meppel",
      "es": "Meppel",
      "fr": "Meppel",
      "nl": "Meppel"
    },
    "names": [
      "Meppel"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "netherlands": {
    "count": 7274,
    "countAllTime": 176389,
    "localizedNames": {
      "de": "Niederlande",
      "en": "Netherlands",
      "es": "Países Bajos",
      "fr": "Pays-Bas",
      "nl": "Nederland"
    },
    "names": [
      "Netherlands",
      "nl",
      "the netherlands",
      "kingdom of the netherlands",
      "holland",
      "nederland",
      "nederlanden",
      "niederlande",
      "belanda",
      "holanda"
    ],
    "platformsCount": 0,
    "type": "COUNTRY"
  },
  "nieuwe-westen": {
    "count": 34,
    "countAllTime": 34,
    "localizedNames": {
      "de": "Nieuwe Westen",
      "en": "Nieuwe Westen",
      "es": "Nieuwe Westen",
      "fr": "Nieuwe Westen",
      "nl": "Nieuwe Westen"
    },
    "names": [
      "Nieuwe Westen"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "nieuwegein": {
    "count": 17,
    "countAllTime": 569,
    "localizedNames": {
      "de": "Nieuwegein",
      "en": "Nieuwegein",
      "es": "Nieuwegein",
      "fr": "Nieuwegein",
      "nl": "Nieuwegein"
    },
    "names": [
      "Nieuwegein"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "nijmegen": {
    "count": 63,
    "countAllTime": 2135,
    "localizedNames": {
      "de": "Nijmegen",
      "en": "Nijmegen",
      "es": "Nimega",
      "fr": "Nimègue",
      "nl": "Nijmegen"
    },
    "names": [
      "Nijmegen",
      "Nimega",
      "Nimègue"
    ],
    "platformsCount": 5,
    "type": "CITY"
  },
  "nijmegen-centrum": {
    "count": 13,
    "countAllTime": 489,
    "localizedNames": {
      "de": "Nijmegen-Centrum",
      "en": "Nijmegen-Centrum",
      "es": "Nijmegen-Centrum",
      "fr": "Nijmegen-Centrum",
      "nl": "Nijmegen-Centrum"
    },
    "names": [
      "Nijmegen-Centrum"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "nijmegen-oost": {
    "count": 16,
    "countAllTime": 640,
    "localizedNames": {
      "de": "Nijmegen-Oost",
      "en": "Nijmegen-Oost",
      "es": "Nijmegen-Oost",
      "fr": "Nijmegen-Oost",
      "nl": "Nijmegen-Oost"
    },
    "names": [
      "Nijmegen-Oost"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "noord-brabant": {
    "count": 1282,
    "countAllTime": 23550,
    "localizedNames": {
      "de": "Nordbrabant",
      "en": "North Brabant",
      "es": "Brabante Septentrional",
      "fr": "Brabant-Septentrional",
      "nl": "Noord-Brabant"
    },
    "names": [
      "Noord-Brabant",
      "North Brabant",
      "Nordbrabant",
      "Brabante Septentrional",
      "Põhja-Brabant",
      "Pohjois-Brabant",
      "Brabant-Septentrional",
      "Norður-Brabant",
      "Brabancja Północna"
    ],
    "platformsCount": 52,
    "type": "PROVINCE"
  },
  "noord-holland": {
    "count": 1654,
    "countAllTime": 42620,
    "localizedNames": {
      "de": "Nordholland",
      "en": "North Holland",
      "es": "Holanda Septentrional",
      "fr": "Hollande-Septentrionale",
      "nl": "Noord-Holland"
    },
    "names": [
      "Noord-Holland",
      "North Holland",
      "Nordholland",
      "Holanda Septentrional",
      "Põhja-Holland",
      "Pohjois-Holland",
      "Hollande-Septentrionale",
      "Norður-Holland",
      "Holandia Północna"
    ],
    "platformsCount": 61,
    "type": "PROVINCE"
  },
  "noord-hoorn": {
    "count": 70,
    "countAllTime": 439,
    "localizedNames": {
      "de": "Hoorn",
      "en": "Hoorn",
      "es": "Hoorn",
      "fr": "Hoorn",
      "nl": "Hoorn"
    },
    "names": [
      "Hoorn",
      "Blokker",
      "Zwaag"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "noord-medemblik": {
    "count": 33,
    "countAllTime": 105,
    "localizedNames": {
      "de": "Medemblik",
      "en": "Medemblik",
      "es": "Medemblik",
      "fr": "Medemblik",
      "nl": "Medemblik"
    },
    "names": [
      "Medemblik",
      "Andijk",
      "Wervershoof",
      "Midwoud"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "noord-veldhoven": {
    "count": 16,
    "countAllTime": 382,
    "localizedNames": {
      "de": "Veldhoven",
      "en": "Veldhoven",
      "es": "Veldhoven",
      "fr": "Veldhoven",
      "nl": "Veldhoven"
    },
    "names": [
      "Veldhoven"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "noord-waterland": {
    "count": 16,
    "countAllTime": 61,
    "localizedNames": {
      "de": "Waterland",
      "en": "Waterland",
      "es": "Waterland",
      "fr": "Waterland",
      "nl": "Waterland"
    },
    "names": [
      "Waterland",
      "Marken",
      "Monnickendam",
      "Broek in Waterland"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "noord-zandvoort": {
    "count": 10,
    "countAllTime": 115,
    "localizedNames": {
      "de": "Zandvoort",
      "en": "Zandvoort",
      "es": "Zandvoort",
      "fr": "Zandvoort",
      "nl": "Zandvoort"
    },
    "names": [
      "Zandvoort"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "nude": {
    "count": 11,
    "countAllTime": 151,
    "localizedNames": {
      "de": "Nude",
      "en": "Nude",
      "es": "Nude",
      "fr": "Nude",
      "nl": "Nude"
    },
    "names": [
      "Nude"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "oldambt": {
    "count": 10,
    "countAllTime": 168,
    "localizedNames": {
      "de": "Oldambt",
      "en": "Oldambt",
      "es": "Oldambt",
      "fr": "Oldambt",
      "nl": "Oldambt"
    },
    "names": [
      "Oldambt",
      "Winschoten"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "oss": {
    "count": 15,
    "countAllTime": 425,
    "localizedNames": {
      "de": "Oss",
      "en": "Oss",
      "es": "Oss",
      "fr": "Oss",
      "nl": "Oss"
    },
    "names": [
      "Oss",
      "Os"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "oude-noorden": {
    "count": 20,
    "countAllTime": 20,
    "localizedNames": {
      "de": "Oude Noorden",
      "en": "Oude Noorden",
      "es": "Oude Noorden",
      "fr": "Oude Noorden",
      "nl": "Oude Noorden"
    },
    "names": [
      "Oude Noorden"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "overi-kampen": {
    "count": 9,
    "countAllTime": 313,
    "localizedNames": {
      "de": "Kampen",
      "en": "Kampen",
      "es": "Kampen",
      "fr": "Kampen",
      "nl": "Kampen"
    },
    "names": [
      "Kampen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "overi-zwolle": {
    "count": 85,
    "countAllTime": 1630,
    "localizedNames": {
      "de": "Zwolle",
      "en": "Zwolle",
      "es": "Zwolle",
      "fr": "Zwolle",
      "nl": "Zwolle"
    },
    "names": [
      "Zwolle"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "overijssel": {
    "count": 380,
    "countAllTime": 10247,
    "localizedNames": {
      "de": "Overijssel",
      "en": "Overijssel",
      "es": "Overijssel",
      "fr": "Overijssel",
      "nl": "Overijssel"
    },
    "names": [
      "Overijssel"
    ],
    "platformsCount": 8,
    "type": "PROVINCE"
  },
  "paleiskwartier": {
    "count": 16,
    "countAllTime": 16,
    "localizedNames": {
      "de": "Paleiskwartier",
      "en": "Paleiskwartier",
      "es": "Paleiskwartier",
      "fr": "Paleiskwartier",
      "nl": "Paleiskwartier"
    },
    "names": [
      "Paleiskwartier"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "prins-alexander": {
    "count": 23,
    "countAllTime": 773,
    "localizedNames": {
      "de": "Prins Alexander",
      "en": "Prins Alexander",
      "es": "Prins Alexander",
      "fr": "Prins Alexander",
      "nl": "Prins Alexander"
    },
    "names": [
      "Prins Alexander"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "purmerend": {
    "count": 146,
    "countAllTime": 802,
    "localizedNames": {
      "de": "Purmerend",
      "en": "Purmerend",
      "es": "Purmerend",
      "fr": "Purmerend",
      "nl": "Purmerend"
    },
    "names": [
      "Purmerend",
      "Middenbeemster",
      "Zuidoostbeemster"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "roermond": {
    "count": 24,
    "countAllTime": 727,
    "localizedNames": {
      "de": "Roermond",
      "en": "Roermond",
      "es": "Roermond",
      "fr": "Ruremonde",
      "nl": "Roermond"
    },
    "names": [
      "Roermond",
      "Ruraemunde",
      "Ruremonde"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "roosendaal": {
    "count": 19,
    "countAllTime": 691,
    "localizedNames": {
      "de": "Roosendaal",
      "en": "Roosendaal",
      "es": "Roosendaal",
      "fr": "Roosendaal",
      "nl": "Roosendaal"
    },
    "names": [
      "Roosendaal"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "rotte-delfshaven": {
    "count": 90,
    "countAllTime": 1844,
    "localizedNames": {
      "de": "Delfshaven",
      "en": "Delfshaven",
      "es": "Delfshaven",
      "fr": "Delfshaven",
      "nl": "Delfshaven"
    },
    "names": [
      "Delfshaven"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "rotte-feijenoord": {
    "count": 107,
    "countAllTime": 1782,
    "localizedNames": {
      "de": "Feijenoord",
      "en": "Feijenoord",
      "es": "Feijenoord",
      "fr": "Feijenoord",
      "nl": "Feijenoord"
    },
    "names": [
      "Feijenoord"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "rotte-noord": {
    "count": 73,
    "countAllTime": 1492,
    "localizedNames": {
      "de": "Noord",
      "en": "Noord",
      "es": "Noord",
      "fr": "Noord",
      "nl": "Noord"
    },
    "names": [
      "Noord"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "rotterdam": {
    "count": 611,
    "countAllTime": 12810,
    "localizedNames": {
      "de": "Rotterdam",
      "en": "Rotterdam",
      "es": "Róterdam",
      "fr": "Rotterdam",
      "nl": "Rotterdam"
    },
    "names": [
      "Rotterdam",
      "Rotjeknor",
      "Róterdam"
    ],
    "platformsCount": 52,
    "type": "CITY"
  },
  "s-her-binnenstad": {
    "count": 11,
    "countAllTime": 71,
    "localizedNames": {
      "de": "Binnenstad",
      "en": "Binnenstad",
      "es": "Binnenstad",
      "fr": "Binnenstad",
      "nl": "Binnenstad"
    },
    "names": [
      "Binnenstad"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "s-her-west": {
    "count": 24,
    "countAllTime": 215,
    "localizedNames": {
      "de": "West",
      "en": "West",
      "es": "West",
      "fr": "West",
      "nl": "West"
    },
    "names": [
      "West"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "s-hertogenbosch": {
    "count": 69,
    "countAllTime": 1593,
    "localizedNames": {
      "de": "'s-Hertogenbosch",
      "en": "'s-Hertogenbosch",
      "es": "Bolduque",
      "fr": "Bois-le-Duc",
      "nl": "'s-Hertogenbosch"
    },
    "names": [
      "'s-Hertogenbosch",
      "Den Bosch",
      "sHertogenbosch",
      "s’-Hertogenbosch",
      "Bolduque",
      "Bois-le-Duc",
      "Rosmalen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "schagen": {
    "count": 8,
    "countAllTime": 92,
    "localizedNames": {
      "de": "Schagen",
      "en": "Schagen",
      "es": "Schagen",
      "fr": "Schagen",
      "nl": "Schagen"
    },
    "names": [
      "Schagen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "schiedam": {
    "count": 30,
    "countAllTime": 611,
    "localizedNames": {
      "de": "Schiedam",
      "en": "Schiedam",
      "es": "Schiedam",
      "fr": "Schiedam",
      "nl": "Schiedam"
    },
    "names": [
      "Schiedam"
    ],
    "platformsCount": 3,
    "type": "CITY"
  },
  "sdwest-frysln": {
    "count": 13,
    "countAllTime": 324,
    "localizedNames": {
      "de": "Súdwest-Fryslân",
      "en": "Súdwest-Fryslân",
      "es": "Súdwest-Fryslân",
      "fr": "Súdwest-Fryslân",
      "nl": "Súdwest-Fryslân"
    },
    "names": [
      "Súdwest-Fryslân",
      "Sneek"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "sittard-geleen": {
    "count": 36,
    "countAllTime": 997,
    "localizedNames": {
      "de": "Sittard-Geleen",
      "en": "Sittard-Geleen",
      "es": "Sittard-Geleen",
      "fr": "Sittard-Geleen",
      "nl": "Sittard-Geleen"
    },
    "names": [
      "Sittard-Geleen",
      "Geleen",
      "Sittard"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "smallingerland": {
    "count": 13,
    "countAllTime": 381,
    "localizedNames": {
      "de": "Smallingerland",
      "en": "Smallingerland",
      "es": "Smallingerland",
      "fr": "Smallingerland",
      "nl": "Smallingerland"
    },
    "names": [
      "Smallingerland",
      "Drachten"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "spijkerkwartier": {
    "count": 12,
    "countAllTime": 192,
    "localizedNames": {
      "de": "Spijkerkwartier",
      "en": "Spijkerkwartier",
      "es": "Spijkerkwartier",
      "fr": "Spijkerkwartier",
      "nl": "Spijkerkwartier"
    },
    "names": [
      "Spijkerkwartier"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "stede-broec": {
    "count": 22,
    "countAllTime": 62,
    "localizedNames": {
      "de": "Stede Broec",
      "en": "Stede Broec",
      "es": "Stede Broec",
      "fr": "Stede Broec",
      "nl": "Stede Broec"
    },
    "names": [
      "Stede Broec",
      "Bovenkarspel",
      "Grootebroek"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "stichtse-vecht": {
    "count": 8,
    "countAllTime": 137,
    "localizedNames": {
      "de": "Stichtse Vecht",
      "en": "Stichtse Vecht",
      "es": "Stichtse Vecht",
      "fr": "Stichtse Vecht",
      "nl": "Stichtse Vecht"
    },
    "names": [
      "Stichtse Vecht",
      "Maarssen"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "terneuzen": {
    "count": 11,
    "countAllTime": 240,
    "localizedNames": {
      "de": "Terneuzen",
      "en": "Terneuzen",
      "es": "Terneuzen",
      "fr": "Terneuzen",
      "nl": "Terneuzen"
    },
    "names": [
      "Terneuzen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "tilbu-groenewoud": {
    "count": 11,
    "countAllTime": 233,
    "localizedNames": {
      "de": "Groenewoud",
      "en": "Groenewoud",
      "es": "Groenewoud",
      "fr": "Groenewoud",
      "nl": "Groenewoud"
    },
    "names": [
      "Groenewoud"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "tilburg": {
    "count": 165,
    "countAllTime": 4208,
    "localizedNames": {
      "de": "Tilburg",
      "en": "Tilburg",
      "es": "Tilburg",
      "fr": "Tilbourg",
      "nl": "Tilburg"
    },
    "names": [
      "Tilburg",
      "Tilbourg"
    ],
    "platformsCount": 4,
    "type": "CITY"
  },
  "utrecht": {
    "count": 264,
    "countAllTime": 7854,
    "localizedNames": {
      "de": "Utrecht",
      "en": "Utrecht",
      "es": "Utrecht",
      "fr": "Utrecht",
      "nl": "Utrecht"
    },
    "names": [
      "Utrecht"
    ],
    "platformsCount": 49,
    "type": "CITY"
  },
  "utrecht-province": {
    "count": 403,
    "countAllTime": 12053,
    "localizedNames": {
      "de": "Utrecht",
      "en": "Utrecht",
      "es": "Utrecht",
      "fr": "Utrecht",
      "nl": "Utrecht"
    },
    "names": [
      "Utrecht"
    ],
    "platformsCount": 49,
    "type": "PROVINCE"
  },
  "venlo": {
    "count": 21,
    "countAllTime": 549,
    "localizedNames": {
      "de": "Venlo",
      "en": "Venlo",
      "es": "Venlo",
      "fr": "Venlo",
      "nl": "Venlo"
    },
    "names": [
      "Venlo"
    ],
    "platformsCount": 3,
    "type": "CITY"
  },
  "vlaardingen": {
    "count": 8,
    "countAllTime": 202,
    "localizedNames": {
      "de": "Vlaardingen",
      "en": "Vlaardingen",
      "es": "Vlaardingen",
      "fr": "Flardingue",
      "nl": "Vlaardingen"
    },
    "names": [
      "Vlaardingen",
      "Flardingue"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "vlissingen": {
    "count": 18,
    "countAllTime": 349,
    "localizedNames": {
      "de": "Vlissingen",
      "en": "Vlissingen",
      "es": "Flesinga",
      "fr": "Flessingue",
      "nl": "Vlissingen"
    },
    "names": [
      "Vlissingen",
      "Flesinga",
      "Flessingue"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "wagen-noordwest": {
    "count": 13,
    "countAllTime": 103,
    "localizedNames": {
      "de": "Noordwest",
      "en": "Noordwest",
      "es": "Noordwest",
      "fr": "Noordwest",
      "nl": "Noordwest"
    },
    "names": [
      "Noordwest"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "wageningen": {
    "count": 59,
    "countAllTime": 1379,
    "localizedNames": {
      "de": "Wageningen",
      "en": "Wageningen",
      "es": "Wageningen",
      "fr": "Wageningue",
      "nl": "Wageningen"
    },
    "names": [
      "Wageningen",
      "Wageningue"
    ],
    "platformsCount": 3,
    "type": "CITY"
  },
  "wassenaar": {
    "count": 16,
    "countAllTime": 358,
    "localizedNames": {
      "de": "Wassenaar",
      "en": "Wassenaar",
      "es": "Wassenaar",
      "fr": "Wassenaar",
      "nl": "Wassenaar"
    },
    "names": [
      "Wassenaar"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "weesp-binnenstad": {
    "count": 106,
    "countAllTime": 5710,
    "localizedNames": {
      "de": "Weesp Binnenstad",
      "en": "Weesp Binnenstad",
      "es": "Weesp Binnenstad",
      "fr": "Weesp Binnenstad",
      "nl": "Weesp Binnenstad"
    },
    "names": [
      "Weesp Binnenstad",
      "Zuid"
    ],
    "platformsCount": 0,
    "type": "BOROUGH"
  },
  "zaanstad": {
    "count": 31,
    "countAllTime": 693,
    "localizedNames": {
      "de": "Zaanstad",
      "en": "Zaanstad",
      "es": "Zaanstad",
      "fr": "Zaanstad",
      "nl": "Zaanstad"
    },
    "names": [
      "Zaanstad",
      "Koog aan de Zaan",
      "Zaandam"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "zeeland": {
    "count": 86,
    "countAllTime": 2292,
    "localizedNames": {
      "de": "Seeland",
      "en": "Zeeland",
      "es": "Zelanda",
      "fr": "Zélande",
      "nl": "Zeeland"
    },
    "names": [
      "Zeeland",
      "Seeland",
      "Zelanda",
      "Zélande",
      "Zelandia"
    ],
    "platformsCount": 5,
    "type": "PROVINCE"
  },
  "zeist": {
    "count": 19,
    "countAllTime": 485,
    "localizedNames": {
      "de": "Zeist",
      "en": "Zeist",
      "es": "Zeist",
      "fr": "Zeist",
      "nl": "Zeist"
    },
    "names": [
      "Zeist"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "zoetermeer": {
    "count": 49,
    "countAllTime": 778,
    "localizedNames": {
      "de": "Zoetermeer",
      "en": "Zoetermeer",
      "es": "Zoetermeer",
      "fr": "Zoetermeer",
      "nl": "Zoetermeer"
    },
    "names": [
      "Zoetermeer"
    ],
    "platformsCount": 2,
    "type": "CITY"
  },
  "zuid-holland": {
    "count": 1650,
    "countAllTime": 39787,
    "localizedNames": {
      "de": "Südholland",
      "en": "South Holland",
      "es": "Holanda Meridional",
      "fr": "Hollande-Méridionale",
      "nl": "Zuid-Holland"
    },
    "names": [
      "Zuid-Holland",
      "South Holland",
      "Südholland",
      "Holanda Meridional",
      "Lõuna-Holland",
      "Etelä-Holland",
      "Hollande-Méridionale",
      "Suður-Holland",
      "Holandia Południowa"
    ],
    "platformsCount": 62,
    "type": "PROVINCE"
  },
  "zuid-noordwijk": {
    "count": 14,
    "countAllTime": 310,
    "localizedNames": {
      "de": "Noordwijk",
      "en": "Noordwijk",
      "es": "Noordwijk",
      "fr": "Noordwijk",
      "nl": "Noordwijk"
    },
    "names": [
      "Noordwijk"
    ],
    "platformsCount": 0,
    "type": "CITY"
  },
  "zuid-rijswijk": {
    "count": 37,
    "countAllTime": 580,
    "localizedNames": {
      "de": "Rijswijk",
      "en": "Rijswijk",
      "es": "Rijswijk",
      "fr": "Ryswick",
      "nl": "Rijswijk"
    },
    "names": [
      "Rijswijk",
      "Ryswick"
    ],
    "platformsCount": 1,
    "type": "CITY"
  },
  "zuidplein": {
    "count": 12,
    "countAllTime": 12,
    "localizedNames": {
      "de": "Zuidplein",
      "en": "Zuidplein",
      "es": "Zuidplein",
      "fr": "Zuidplein",
      "nl": "Zuidplein"
    },
    "names": [
      "Zuidplein"
    ],
    "platformsCount": 0,
    "type": "NEIGHBORHOOD"
  },
  "zutphen": {
    "count": 15,
    "countAllTime": 284,
    "localizedNames": {
      "de": "Zutphen",
      "en": "Zutphen",
      "es": "Zutphen",
      "fr": "Zutphen",
      "nl": "Zutphen"
    },
    "names": [
      "Zutphen"
    ],
    "platformsCount": 1,
    "type": "CITY"
  }
};